<div class="ncb-transfer-declaration-container document-capture-container">
  @if (document.isSubmitted === false) {
    <form [formGroup]="ncbForm">
      <div class="checkbox-control">
        <input
          type="checkbox"
          id="ncbConfirmation"
          formControlName="ncbConfirmed"
          (change)="onChange()"
        />
        <label for="ncbConfirmation" class="customer-confirmation-box">
          @if (document.instructions && document.instructions.length > 0) {
            <span class="instructions-title">Confirmation of the following information:</span>
            <ul class="instructions-list">
              @for (instruction of document.instructions; track instruction) {
                <li [innerHTML]="instruction"></li>
              }
            </ul>
          }
        </label>
      </div>
    </form>
  }

  @if (document.errorMessage) {
    <div class="error-message">
      {{ document.errorMessage }}
      <button (click)="closeErrorMessage()">
        <span class="material-symbols-outlined"> close </span>
      </button>
    </div>
  }

  <app-document-capture-footer
    [isSubmitted]="document.isSubmitted"
    [enableSubmitButton]="document.enableSubmitButton"
    (submitClicked)="onSubmit()"
  ></app-document-capture-footer>
</div>